import Schools from "./Schools";

export default Schools;
